import * as _4 from 'lodash4';
import { ScheduleSection } from '../../builders/schedule_section_builder';
import { MyScheduleHelperFunction } from '../../functions/my_schedule_fn';
import { ScheduleQuery } from '../../queries/schedule_query';
import { CalendarIntegrationService } from '../../services/calendar_integration_service';
import { Schedule } from './../../builders/schedule_builder';
import { CourseScheduleLocalDatabase } from './../../databases/course_schedule_database';

interface IScheduleFlags {
  selectedTab: 'list' | 'schedule';
  hasPhysicalCourses: boolean;
}

export class MyScheduleListController {
  private schedule: ScheduleSection[];
  private temporalSchedule: Schedule[];
  private calendarTimes: any[];
  private term: number;
  private flags: IScheduleFlags;
  private calendarMessage: string;
  private currentTermMsg: string;

  constructor(
    private $state: ng.ui.IStateService,
    private $stateParams: ng.ui.IStateParamsService,
    private ngScheduleQuery: ScheduleQuery,
    private calendarTimeFn: any,
    private myScheduleHelperFn: MyScheduleHelperFunction,
    private ngCalendarIntegrationService: CalendarIntegrationService,
    private log: any
  ) {
    this.flags = {
      selectedTab: _4.isEmpty($stateParams.viewType) ? 'list' : $stateParams.viewType,
      hasPhysicalCourses: false
    };
    this.ngCalendarIntegrationService.callMethod = this.addAllCourseToCalendar();
    const sat = moment().startOf('week').subtract(1, 'day').format('M/D');
    const fri = moment().endOf('week').subtract(1, 'day').format('M/D');
    this.currentTermMsg = `Your schedule for ${sat}-${fri}`;
  }

  $onInit(): void {
    this.refresh();
  }

  $onChanges(): void {
    this.refresh();
  }

  refresh(): void {
    this.schedule = _4.filter(
      _4.sortBy(this.ngScheduleQuery.getSectionsByTerm(this.term), '_course.cd'),
      (section: ScheduleSection) => this.ngScheduleQuery.isRegisteredCourse(section)
    );

    this.calendarMessage = this.ngScheduleQuery.isCurrentTerm(this.term)
      ? this.currentTermMsg
      : `Previewing schedule for all classes throughout this term`;
    this.calendarTimes = this.calendarTimeFn.importTimes(
      this.myScheduleHelperFn.convertScheduleTimesForCalendar(
        this.schedule,
        this.ngScheduleQuery.isCurrentTerm(this.term)
      )
    );
    this.temporalSchedule = this.ngScheduleQuery.getTemporalSectionsByTerm(this.term);
    this.flags.hasPhysicalCourses = !_4.isEmpty(this.temporalSchedule);
    this.ngCalendarIntegrationService.showButton = !_4.isEmpty(this.temporalSchedule);
  }

  isSelectedTab(tab: string): boolean {
    return tab === this.flags.selectedTab;
  }

  selectTab(event: CustomEvent): void {
    const tab: 'list' | 'schedule' = _4.get(event, 'detail.value', this.$stateParams.viewType);

    this.flags.selectedTab = tab || 'list';
    this.$state.go('my.courseSchedule.term', { term: this.term, viewType: tab });
  }

  goToDetailView(time: any): void {
    this.$state.go('my.courseSchedule.detail', {
      id: time.appId
    });
  }

  addAllCourseToCalendar(): () => void {
    return () => {
      this.$state.go('my.add-to-calendar', {
        addCalendarObject: {
          title: 'Add All Courses',
          courses: this.temporalSchedule
        }
      });
    };
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/components/my_schedule_list/my_schedule_list_controller.ts